import { type ShiftForm, type ShiftBatchCreateForm } from '@/api/shifts';

function formatShiftDay(date: string): string {
  return date.split('T')[0] ?? date;
}

function isDayShift(startTime: string, endTime: string): boolean {
  return startTime === '08:00' && endTime === '20:00';
}

function isNightShift(startTime: string, endTime: string): boolean {
  return startTime === '20:00' && endTime === '08:00';
}

function determineShiftType(startTime: string, endTime: string):
  { dayShift: boolean; nightShift: boolean; customShift: boolean } {
  const dayShift = isDayShift(startTime, endTime);
  const nightShift = isNightShift(startTime, endTime);

  return {
    dayShift,
    nightShift,
    customShift: !dayShift && !nightShift,
  };
}

function transformShiftToShiftBatchCreateForm(shift: ShiftForm): ShiftBatchCreateForm {
  return {
    patientId: shift.patientId,
    caregiversIds: [shift.caregiverId],
    caregiversShifts: [
      [
        {
          day: formatShiftDay(shift.date!),
          ...determineShiftType(shift.startTime, shift.endTime),
        },
      ],
    ],
    caregiverWeekShiftCost: shift.caregiverCost,
    caregiverWeekendShiftCost: shift.caregiverCost,
    weekShiftPrice: shift.price,
    weekendShiftPrice: shift.price,
    caregiverWeekShiftCostPerHour: shift.caregiverCostPerHour,
    caregiverWeekendShiftCostPerHour: shift.caregiverCostPerHour,
    weekShiftPricePerHour: shift.pricePerHour,
    weekendShiftPricePerHour: shift.pricePerHour,
    withTaxBill: shift.withTaxBill,
    startTime: shift.startTime,
    endTime: shift.endTime,
    startDate: '',
  };
}

export { transformShiftToShiftBatchCreateForm };

